import { render, staticRenderFns } from "./ModalCreateOrUpdateCriteria.vue?vue&type=template&id=e6d97380&"
import script from "./ModalCreateOrUpdateCriteria.vue?vue&type=script&lang=js&"
export * from "./ModalCreateOrUpdateCriteria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports